module.exports = __webpack_public_path__ + "static/media/web1.cbaf2a21.png";